import { styled } from '@mui/system'
import { AnimatedDiv } from '@/ui/components/animatedDiv/animatedDiv.styles'
import { SearchInput } from '@/ui/components/search-input'

export const sectionAnimationProps = {
    initial: { height: 0, opacity: 0 },
    animate: { height: 'auto', opacity: 1 },
    exit: { height: 0, opacity: 0 },
    transition: {
        duration: 0.35,
        ease: [0.4, 0, 0.2, 1],
    },
}

export const SectionContent = styled(AnimatedDiv)`
    overflow: hidden;
`

export const StyledSearchInput = styled(SearchInput)`
    margin: 8px 0;
`
